import styled, { css } from "styled-components";
import colours from "assets/colours";
import zIndex from "constants/zIndex";

const PopUp = styled.div`
  visibility: hidden;
  position: absolute;
  top: 0px;
  right: -1.5em;
  background: #ffffff;
  box-shadow: 10px 10px 45px rgba(108, 109, 133, 0.15);
  border-radius: 25px;
  padding: 22px;
  width: 340px;
  max-width: 80vw;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: ${colours.grey2};
  z-index: ${zIndex.tooltip};

  ${({ visible }) =>
    visible &&
    css`
      visibility: visible;
    `}

  ${({ positionX }) => {
    return positionX === "left"
      ? css`
          left: -1.5em;
          &:after {
            left: 1.5em;
          }
        `
      : css`
          right: -1.5em;
          &:after {
            right: 1.5em;
          }
        `;
  }}

  &:after {
    display: inherit;
    content: "";
    width: 25px;
    height: 25px;
    transform: rotate(45deg);
    background: ${colours.white};
    position: absolute;
    right: 1.5em;
    bottom: -10px;
  }
`;

const Container = styled.div`
  position: relative;
  height: 25px;

  &:hover {
    svg {
      path {
        stroke: ${colours.lightBlue};
      }
      path:last-child {
        fill: ${colours.lightBlue};
        stroke-width: 0;
      }
    }
  }
`;

export { Container, PopUp };
